import { Button } from "@/components/ui/button";

interface ChoiceButtonsProps<T extends string> {
  label: string;
  options: Array<{ value: T; label: string }>;
  value: T | null;
  onChange: (value: T) => void;
}

/** A row of toggle buttons where exactly one (or none yet) is pressed. */
function ChoiceButtons<T extends string>({
  label,
  options,
  value,
  onChange,
}: ChoiceButtonsProps<T>) {
  return (
    <div role="group" aria-label={label} className="flex flex-wrap gap-2">
      {options.map(option => (
        <Button
          key={option.value}
          type="button"
          size="sm"
          variant={value === option.value ? "default" : "outline"}
          aria-pressed={value === option.value}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
}

export default ChoiceButtons;
